import React from 'react';
import styles from './modals.module.css'
import {createPortal} from "react-dom";
import {useDispatch, useSelector} from "react-redux";
import useEscape from "../../../../helper/keypressListeners/escape";
import {getReviewerHistory} from "../../../../api/reviewsAPI";
import {setDocToView} from "../../../../store/navSlice";

const HistoryModal = ({open, closeModal, isPrimary = true}) => {

    const docket = useSelector((state) => state.navigation.currentDocket);
    const jwt = useSelector((state) => state.user.jwt);
    const dispatch = useDispatch();

    const [history, setHistory] = React.useState([])

    const clearAndCloseModal = () => {
        closeModal()
    }

    useEscape(clearAndCloseModal)

    React.useEffect(() => {
        getReviewerHistory(jwt, docket, isPrimary).then(r => {
            if (r.success) {
                setHistory(r.data)
            } else {
                setHistory([])
            }
        })
    }, [jwt, docket, isPrimary])

    return createPortal(
        <div autoFocus={false} role={'dialog'} style={{display: open ? 'flex' : 'none'}} aria-modal={true}
             aria-hidden={!open} onClick={clearAndCloseModal}
             className={styles.wrapper} aria-describedby={'modalDescription'}>
            <div className={styles.content} onClick={(event)=>{event.stopPropagation();}}>
                <div className={styles.modalDescription} id={'modalDescription'}>
                    This is a dialog window which overlays the main content of the page.
                    The modal begins with a heading called &quot;Reviewer History&quot;.
                    Pressing the Close Modal button at the top will close the modal and bring you back to where you were
                    on the page.
                </div>
                <h1 className={styles.h1}>Reviewer History ({isPrimary ? "Primary" : "QA"})</h1>
                <button className={styles.closeX} title={"Close Modal"} aria-label={"Close Modal"} autoFocus={true}
                        onClick={clearAndCloseModal}>X
                </button>
                {
                    history.map(historyItem => (
                        <div key={historyItem[0]} className={styles.lineItem}>
                            <p onClick={() => dispatch(setDocToView(historyItem[0] ?? ""))}
                               className={styles.textButton}>{historyItem[0]} ({historyItem[1]})</p>
                        </div>
                    ))
                }
            </div>
        </div>,
        document.body
    );
};

export default HistoryModal;